module.exports = __webpack_public_path__ + "img/Manila Mobility Cover_Page_01.167e70b7.png";